export default __webpack_public_path__ + "static/media/pooltogether-icon.1d55ea30.png";